import { AuditProgramAIRDTO } from './audit-program-air-dto';
import { AuditSummaryAIRCountBean } from './audit-summary-air-count-bean';

export class AuditProgramAIRResponse {
    auditProgramAIRDepartmentList: AuditProgramAIRDepartmentDTO[]=[];
    auditProgramAIRList: AuditProgramAIRDTO[]=[];
    auditSummaryAIRCountList: AuditSummaryAIRCountBean[]=[];
}


export class AuditProgramAIRDepartmentDTO {
    departmentName: string;
    isopen: boolean = false;
    checked: boolean = false;
    departmentId: string;
    airItemCount: number;
    auditId: string;

}


